import { ELEMENTSTYPESIDS } from "../shared/constants/elementsTypesIds";

export interface ElementResultInfo {
  id: string;
  Label?: string
  AssetId?: string;
  RegionIds?: Array<string>;
  ResultValue?: any;
  CheckList?: any;
  IsPlanned: boolean;
  InsertedRegionId: string;
  Element: any;
  InspectionMethodId?: string;
  InspectionTypeId?: string;
  InspectionTypeAlias?: string;
  ElementInfo?: ElementInfo;
  TargetGeometryId: string;
  TargetGeometryIds?: Array<string>;
  TargetGeometryTypeId: ELEMENTSTYPESIDS;
  Scope: string;
  SectionId: string;
  Status?: Status;
  TargetLabels?: string;
  IsOfflineInspection?: boolean;
  OfflineInspectionStatus?: OfflineInspectionStatus;
  Active?: boolean,
  EndDate?: Date,

  //#region Degradation

  ReadingQuality?: any;
  ExposureTime?: number;
  EstimatedLostThickness?: number;
  EstimatedThickness?: number;
  AbsoluteDegradation?: number;
  CorrosionRiskIndex?: number;
  RelativeDegradation?: number;
  CorrosionRate?: number;
  RemainingLife?: number;

  //#endregion

  // Scout drone-session import provenance — set when the inspection is created from a ScoutDI
  // UTM/POI, used to dedupe already-imported points on subsequent imports.
  ScoutImportId?: string;
  ScoutSessionCode?: string;

}

export interface ElementInfo {
  type: string;
  vertices: Array<number>;
  holes?: Array<Array<number>>;
  faces?: Array<number>;
  normal?: Array<number>;
}

export enum Status {
  Outlined,
  Skipped,
  Executed
}

export enum OfflineInspectionStatus {
  NA,
  Pending,
  Approved,
  Rejected
}
